import $ from 'jquery';

const defaults = {
  selector: '.node-header a',
};

function RemoveAria(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.deleteAria();
}

RemoveAria.prototype = {
  deleteAria() {
    return this.$element.find(this.settings.selector).removeAttr('aria-label');
  },
};

export default RemoveAria;
